import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import SignerActions from "../aadeSigners/SignerActions";
import axios from "axios";

const TableForSigneres = ({
  columns,
  signers,
  deletedAfms,
  setSigners,
  setSelectedAfm,
  setDeleteDialogOpen,
  setNotification,
  setDeletedAfms,
  fetchUrl,
}) => {
  const fetchSigners = async () => {
    try {
      setSigners([]);
      const response = await axios.get(fetchUrl, {
        withCredentials: true,
      });
      setSigners(response.data);
    } catch (error) {
      console.error("Error fetching signers:", error);
    }
  };

  useEffect(() => {
    fetchSigners();
  }, [fetchUrl]);

  return (
    <Box sx={{ textAlign: "center", margin: "auto", width: "80%" }}>
      {signers.length > 0 ? (
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  style={{ fontWeight: "bold", fontSize: "18px" }}
                >
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {signers.map((row, index) => (
              <TableRow
                key={index}
                style={{
                  background: deletedAfms.includes(row.afm)
                    ? "#D3D3D3"
                    : row.isNew
                      ? "#d7faf2"
                      : "inherit",
                }}
              >
                {columns.map((column, columnIndex) => (
                  <TableCell key={columnIndex}>
                    {column.field === "actions" ? (
                      <SignerActions
                        row={row}
                        deletedAfms={deletedAfms}
                        signers={signers}
                        setSigners={setSigners}
                        setSelectedAfm={setSelectedAfm}
                        setDeleteDialogOpen={setDeleteDialogOpen}
                        setNotification={setNotification}
                        setDeletedAfms={setDeletedAfms}
                      />
                    ) : (
                      row[column.field]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography
          variant="h4"
          color="textSecondary"
          sx={{ fontWeight: "bold", marginTop: "20px" }}
        >
          Δεν υπάρχουν δεδομένα.
        </Typography>
      )}
    </Box>
  );
};

export default TableForSigneres;
